import api from './config'

export function fetchBlog(id) {
  return api(`/posts/?point=${id}`);
}
